import { AllowListStatus } from 'src/utils/types';
import styles from './styles.module.scss';
export const allowListStatusMap = {
  [AllowListStatus.CLOSED]: {
    style: styles.closed,
    text: 'Allowlist Closed'
  },
  [AllowListStatus.OPEN]: {
    style: styles.open,
    text: 'Allowlist Open'
  },
  [AllowListStatus.SOON]: {
    style: styles.upComing,
    text: 'Allowlist Soon'
  },
  [AllowListStatus.REFUNDED]: {
    style: styles.refunded,
    text: 'Allowlist Refunded'
  }
};